import { render, staticRenderFns } from "./BaseMenuPolygonList.vue?vue&type=template&id=d84d7308&scoped=true"
import script from "./BaseMenuPolygonList.vue?vue&type=script&lang=js"
export * from "./BaseMenuPolygonList.vue?vue&type=script&lang=js"
import style0 from "./BaseMenuPolygonList.vue?vue&type=style&index=0&id=d84d7308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84d7308",
  null
  
)

export default component.exports